import { UserEditList } from "../../../shared/screen-components/UserAccessEditComponent/UserAcessEdit";
import { StyledProjectSection } from "../../DeliverableView/pages/DeliverableDetails/DeliverableDetails.styles";

const UserAccessEdit = () => {
  return (
    <StyledProjectSection>
      <UserEditList />
    </StyledProjectSection>
  );
};

export default UserAccessEdit;
